// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8e8f9947","455":"59926298","977":"4e39d11a"}[chunkId] + ".chunk.js";
};